import { useActiveWorkoutSession } from "@/hooks/useActiveWorkoutSession";
import WorkoutStateManager from "@/components/workout/WorkoutStateManager";

export default function ActiveWorkoutRoute() {
  const session = useActiveWorkoutSession();
  return <WorkoutStateManager {...session} />;
}